// extracted by mini-css-extract-plugin
export default {"pageContainer":"SearchResult_pageContainer__QR6k7","noData":"SearchResult_noData__Jjx1O"};